import React from "react";
import { Checkbox, DateTimeInput, HTMLInput, Input, Select, TextArea, } from ".";
import { useTranslation } from "./hooks/useTranslation";
import { isEmail, isInteger, isNumber, isURL } from "./utils/validators";
import { DEFAULT_ID } from "./withFormWrapper";
import { stripTrailingDotZero } from "./utils/formatters";
const all = (builtInValidator, customValidator) => (v) => {
    if (builtInValidator) {
        const result = builtInValidator(v);
        if (typeof result === "string") {
            return result;
        }
    }
    if (customValidator) {
        return customValidator(v);
    }
    return true;
};
export const CustomFieldInput = ({ label, name, type, options = [], disabled = false, valid: customValidator, required = false, onChange, uniqueId = DEFAULT_ID, additionalInputProps, dataId, dataTestId, }) => {
    const t = useTranslation();
    const isBlankOrEmail = (v) => !v || isEmail(v) || t("Value must be a valid email");
    const isBlankOrUrl = (v) => !v || isURL(v) || t("Value must be a valid URL");
    const isBlankOrNumber = (v) => !v || isNumber(v) || t("Value must be a number");
    const isBlankOrInteger = (v) => !v || isInteger(v) || t("Value must be an integer");
    const commonProps = {
        label,
        name,
        disabled,
        required,
        uniqueId,
        dataId,
        dataTestId,
        onChange,
    };
    switch (type) {
        case "string":
            return React.createElement(Input, { ...commonProps, valid: customValidator });
        case "url":
            return (React.createElement(Input, { ...commonProps, valid: (v) => all(isBlankOrUrl, customValidator)(v) }));
        case "email":
            return (React.createElement(Input, { ...commonProps, valid: (v) => all(isBlankOrEmail, customValidator)(v) }));
        case "text":
            return React.createElement(TextArea, { ...commonProps, valid: customValidator });
        case "html":
            return React.createElement(HTMLInput, { ...commonProps, valid: customValidator });
        case "number":
            return (React.createElement(Input, { ...commonProps, staticFormatter: stripTrailingDotZero, valid: (v) => all(isBlankOrNumber, customValidator)(v) }));
        case "integer":
            return (React.createElement(Input, { ...commonProps, valid: (v) => all(isBlankOrInteger, customValidator)(v) }));
        case "checkbox":
            return (React.createElement(Checkbox, { name,
                disabled,
                required,
                uniqueId,
                dataId,
                dataTestId,
                onChange, description: label, valid: customValidator }));
        case "choice":
        case "country":
        case "language":
        case "location":
        case "contact":
            return (React.createElement(Select, { ...commonProps, options: options ? options : [], valid: customValidator }));
        case "locations":
        case "contacts":
        case "multichoice":
            return (React.createElement(Select, { multiple: true, ...commonProps, options: options ? options : [], valid: customValidator }));
        case "date":
        case "time":
        case "datetime":
            return (React.createElement(DateTimeInput, { ...commonProps, type: type, valid: customValidator, ...(additionalInputProps || {}) }));
        case "document":
            // Document type not yet supported as we don't have the necessary document picker yet
            return null;
        default:
            return null;
    }
};
